import '@loyal_template/showcases.css'

import React from 'react'
import PropTypes from 'prop-types'

import ShowcasePlaceholder from 'Catalog/Showcase/ShowcasePlaceholder'
import ShowcaseHeader from 'Catalog/Showcase/ShowcaseHeader'
import ShowcaseProductListWrapper from 'Catalog/Showcase/ShowcaseProductListWrapper'

const Showcase = ({
  children,
  isLoading,
  products,
  title,
  mobileTitle,
  id,
  showcaseType,
  identifier
}) =>
  isLoading || id ? (
    <ShowcasePlaceholder isLoading={isLoading && products.length === 0}>
      <div className='showcard-products container-card container py-1 py-md-3 px-0 px-md-0'>
        <ShowcaseHeader
          title={title}
          mobileTitle={mobileTitle}
          viewAllPath={`/search`}
        />
        <ShowcaseProductListWrapper viewAllPath={`/search`}>
          {children}
        </ShowcaseProductListWrapper>
      </div>
    </ShowcasePlaceholder>
  ) : null

Showcase.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  mobileTitle: PropTypes.string,
  isLoading: PropTypes.bool,
  products: PropTypes.array,
  children: PropTypes.any.isRequired,
  showcaseType: PropTypes.number,
  identifier: PropTypes.string
}

export default Showcase



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/Showcase.js